import Image from "next/image";
import Link from "next/link";

export const ImageFile = ({ file }) => {
  const LinkOrDiv = file.link ? Link : "div";

  return (
    <LinkOrDiv href={file.link}>
      <Image
        // sizes="100vw"
        src={file.src}
        width={0}
        height={0}
        alt={file.alt}
        unoptimized
        style={{ width: "100%", height: "auto" }}
      />
    </LinkOrDiv>
  );
};

export default ImageFile;
